import { render, staticRenderFns } from "./sidenavLayout.pug?vue&type=template&id=6507ace2&lang=pug&external"
import script from "./sidenavLayout.js?vue&type=script&lang=js&external"
export * from "./sidenavLayout.js?vue&type=script&lang=js&external"
import style0 from "./sidenavLayout.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6507ace2')) {
      api.createRecord('6507ace2', component.options)
    } else {
      api.reload('6507ace2', component.options)
    }
    module.hot.accept("./sidenavLayout.pug?vue&type=template&id=6507ace2&lang=pug&external", function () {
      api.rerender('6507ace2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sidenavLayout/index.vue"
export default component.exports